import { motion } from "framer-motion";

const steps = [
  {
    img: "/photos/IMG_9508.jpeg",
    alt: "Instructor gently encouraging two children with a rubber duck toy",
    num: "1",
    title: "Book your free trial online",
    text: "Choose any time that suits your family in our live self-booking calendar — no phone tag, no waiting.",
    id: "step-book",
  },
  {
    img: "/photos/IMG_9510.jpeg",
    alt: "Instructor reaching out to encourage a boy with goggles in the water",
    num: "2",
    title: "Meet Coach Abrie at your pool",
    text: "Watch your child bond with Coach Abrie, our Program Director, and her caring instructors in a completely free trial lesson.",
    id: "step-trial",
  },
  {
    img: "/photos/IMG_9503.jpeg",
    alt: "Instructor gently supporting a toddler floating on her back",
    num: "3",
    title: "Lock in 15% off as a resident",
    text: "Love it? Enroll in the 6-week mini session at your resident rate and keep the momentum going all season.",
    id: "step-enroll",
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" data-testid="how-it-works-section" className="scroll-mt-24 bg-white">
      <div className="mx-auto max-w-6xl px-4 sm:px-8 py-16 sm:py-24">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-2xl mx-auto"
        >
          <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#c97049]">Simple as 1 · 2 · 3</p>
          <h2 className="mt-4 font-serif text-2xl sm:text-3xl lg:text-4xl font-bold text-[#00334a]">
            From your living room to their first strokes
          </h2>
        </motion.div>
        <div className="mt-14 grid gap-10 md:grid-cols-3">
          {steps.map((s, i) => (
            <motion.div
              key={s.id}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: i * 0.14 }}
              data-testid={s.id}
              className="text-center"
            >
              <div className="relative mx-auto h-40 w-40">
                <img
                  src={s.img}
                  alt={s.alt}
                  loading="lazy"
                  className="h-40 w-40 rounded-full object-cover border-4 border-[#f2ebd9] shadow-lg"
                />
                <span className="absolute -top-1 -right-1 flex h-10 w-10 items-center justify-center rounded-full bg-[#c97049] font-serif text-lg font-bold text-white shadow-md">
                  {s.num}
                </span>
              </div>
              <h3 className="mt-6 font-serif text-xl sm:text-2xl font-semibold text-[#00334a]">{s.title}</h3>
              <p className="mt-3 text-sm sm:text-base leading-relaxed text-[#00334a]/70 max-w-xs mx-auto">{s.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
